import { setupMap } from "../maps_common";

function setup() {
  if ($("body.attractions.index").length == 0) return; //make it page specific

  let params = qs.parse(location.search.replace("?", ""));
  delete params["gclid"];
  window.infiniteScroll = new InfiniteScroll(
    "body.attractions #results-container",
    {
      // options
      path: function () {
        const page = parseInt($("#results-container").attr("data-next-page"));
        return `//${location.host + location.pathname}?${qs.stringify(
          {
            ...params,
            infinite_page: page, //this.loadCount + 2 //start at page=2
          },
          { arrayFormat: "brackets" }
        )}`;
      },
      checkLastPage: false,
      append: ".attr-wrapper",
      prefill: false,
      history: false,
      scrollThreshold: 600,
      status: ".page-load-status",
      onInit: function () {
        this.on("load", () => {
          //we need to store next page in dom cuz of  turbolinks
          const page = parseInt($("#results-container").attr("data-next-page"));
          $("#results-container").attr("data-next-page", page + 1);
        });
        this.on("append", () => {
          //attach to new loaded items
          FAVOURITES.markAllFavourited();
        });
      },
    }
  );

  $("#more-sublocations-toggler").on("click", (e) => {
    $("#more-sublocations").removeClass("d-none");
    $("#more-sublocations").addClass("d-inline");
    $("#more-sublocations-toggler").hide();
  });

  $("#mobile-filter-categories, #filter-categories").on(
    "click",
    ".filter-row-enabled .filter-checkbox",
    (e) => {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      $(e.currentTarget).find("i,svg").toggleClass("d-none");
      $(e.currentTarget)
        .siblings("a")
        .first()
        .css("text-decoration", "underline");
      //Turbolinks.visit($(e.currentTarget).attr("data-href"));
      window.location.assign($(e.currentTarget).attr("data-href"));
    }
  );

  $("#filter_show_more_link").on("click", (e) => {
    const showedText = $(e.currentTarget).attr("data-showed-title");
    const hiddenText = $(e.currentTarget).attr("data-hidden-title");
    $("#filter_more_categories").toggle();

    if ($(e.currentTarget).html().trim() == hiddenText)
      $(e.currentTarget).html(showedText);
    else $(e.currentTarget).html(hiddenText);
  });

  let map;

  if (isiOS) {
    //prevent pull to refresh on IOS Workaround as Ios doenst support overscroll css yet
    document.getElementById("map-modal").addEventListener("touchmove", (e) => {
      e.preventDefault();
    });
  }
  $("#map-modal").iziModal({
    openFullscreen: true,
    history: false,
    // appendTo: "html", // turbolinks need this
    // appendToOverlay: "html", // turbolinks need this
    onResize: () => {
      $(".modal-content").css("height", $(window).innerHeight()); //set 100% height
    },
    onOpening: () => {
      fixBackgroundScroll();

      if ("gtag" in window) {
        gtag("event", "open", {
          event_category: "Map",
          event_label: `index ${document.location}`,
        });
      }

      if (map) {
        return;
      }

      $.getScript("https://api.mapy.cz/loader.js").done(() => {
        Loader.async = true;
        Loader.load(null, { poi: true }, () => {
          map = setupMap("map-modal-body");
        });
      });
    },
    onClosing: function () {
      unFixBackgroundScroll();
    },
  });

  if (isMobileOrTablet) {
    $("#mobile-filter-categories").iziModal({
      openFullscreen: true,
      onOpening: () => {
        fixBackgroundScroll();
      },
      onClosing: function () {
        unFixBackgroundScroll();
      },
    });
    $("#mobile-sublocations").iziModal({
      openFullscreen: true,
      onOpening: () => {
        fixBackgroundScroll();
      },
      onClosing: function () {
        unFixBackgroundScroll();
      },
    });
  }

  // we load weather dynamically so the rest of the page may be action cached
  jQuery.get($("#weather-container").data("url"), (weatherHtml) => {
    $("#weather-container").html(weatherHtml);
  });

  setupBackToTopButton();

  FAVOURITES.markAllFavourited();
} //setup

function teardown() {
  if ($("body.attractions.index").length == 0) return; //make it page specific

  $("#back-top-button").remove();
  if (window.infiniteScroll) window.infiniteScroll.destroy();
  $("#map-modal-body").empty();
  $("#map-modal").iziModal("destroy");
  $("#mobile-filter-categories").iziModal("destroy");
  $("#mobile-sublocations").iziModal("destroy");
  unFixBackgroundScroll();
} //teardown

$(document).on("DOMContentLoaded", setup); //turbolinks:load
//$(document).on("turbolinks:before-cache", teardown);
